var colors = require('./Colors.js');

// gen options
// Array.from(Array(count), (elem, index) => { let x = index+2; let n = index+10; return { value: x, itemnum: '1.2.' + n, label: 'CoCr Steg auf Klebebasen, ' + x + ' Implantate, gefräst' }; })
const generateOptions = (count, itemnum, label, indexShift, noAmount, itemnumIndexShift) => Array.from(Array(count), (elem, index) => {
  let res = {};
  if (!indexShift)
    indexShift = 1;
  res.value = index + indexShift;
  if (!label)
    res.label = (res.value) + ' Stück';
  else if (typeof label == 'function')
    res.label = label(res.value);
  else
    res.label = label;
  if (itemnum && itemnumIndexShift)
    res.itemnum = itemnum + (index + itemnumIndexShift);
  else if (itemnum)
    res.itemnum = itemnum;
  if (!noAmount)
    res.amount = res.value;
  return res;
});

const generateQuadrants = (itemnum) => [
  {value: 1, amount: 1, itemnum: itemnum, label: '1 Quadrant'},
  {value: 2, amount: 2, itemnum: itemnum, label: '2 Quadranten'},
  {value: 3, amount: 3, itemnum: itemnum, label: '3 Quadranten'},
  {value: 4, amount: 4, itemnum: itemnum, label: '4 Quadranten'},
];

const generateJaw = (itemnum) => [{value: 1, amount: 1, itemnum: itemnum, label: 'Ein Kiefer'}, {value: 2, amount: 2, itemnum: itemnum, label: 'Zwei Kiefer'}];


// Export the tree
module.exports = {
  label: 'Material',
  properties: {
    extendDuedate: {
      label: 'Verlängern der Fälligkeit',
      tooltipSize: 'xlarge',
      tooltip: 'Solltest du einen sehr langen Termin haben, würden wir uns sehr freuen, wenn du uns daran teilhaben lässt. So können wir unsere Produktion effizienter planen und eiligere Arbeiten können schneller in die Bearbeitung gehen. Ein Gewinn für alle, denn jeder hat ja mal was eiliges zwischendurch ☺',
      //itemnum: 'CS482'
    },
  },
  children: {
    ZI: {
      label: 'Zirkon',
      maxunits: 50,
      properties: {
      },
      children: {
        Anatomic: {
          label: 'Zirkon Gerüst/Vollanatomie',
          properties: {
            zi_geschiebe: {
                label: 'Geschiebe',
                type: 'select',
                options: generateOptions(100, '1.1.5')
            },
            zi_teilgeschiebe: {
                label: 'Teilungsgeschiebe',
                type: 'select',
                options: generateOptions(100, '1.1.6')
            },
          },
          children: {
            BredentLuxor: {
              label: 'Bredent Luxor Z',
              tooltip: 'Festigkeit: ≥ 1.100 MPa im cervicalen Bereich und ≥ 750 MPa im höheren incisalen Bereich. Geeignet für mehrspannige Brücken bis 3 Brückenglieder.',
              tooltipSize: 'xlarge',
              itemnum: '1.1.1',
              properties: {
                color: colors(['A1', 'A2', 'A3', 'A3,5', 'A4', 'B1', 'B2', 'B3', 'B4', 'C2', 'C3', 'C4', 'D2', 'D3', 'D4', 'Bleach']),
              }
            },
            CubeXML: {
              label: 'DD cubeX ML',
              tooltip: 'Festigkeit: 700 ± 100 Mpa. Veneers, Inlays, Onlays, Anatomisch reduzierte Krone, Vollanatomische Krone Frontzahn, Vollanatomische Krone Seitenzahn, Anatomisch reduzierte Brücke (bis 1 Brückenglied) und Vollanatomische Brücke (bis 1 Brückenglied)',
              tooltipSize: 'xlarge',
              itemnum: '1.1.2',
              properties: {
                color: colors(['A1', 'A2', 'A3', 'A3,5', 'A4', 'B1', 'B2', 'B3', 'B4', 'C1', 'C2', 'C3', 'C4', 'D2', 'D3', 'D4', 'Bleach']),
              }
            },
            NaceraPearl: {
              label: 'DD Nacera® Pearl Natural',
              tooltip: 'Festigkeit: 1050 ± 150 MPa zervikal. Veneers, Inlays, Onlays, Anatomisch reduzierte Krone, Vollanatomische Krone Frontzahn, Vollanatomische Krone Seitenzahn, Anatomisch reduzierte Brücke (bis 3 Brückenglieder), Anatomisch reduzierte Brücke (bis 14 Glieder), Vollanatomische Brücke (bis 3 Brückenglieder) und Vollanatomische Brücke (bis 14 Glieder)',
              tooltipSize: 'xlarge',
              itemnum: '1.1.3',
              properties: {
                color: colors(['A1', 'A2', 'A3', 'A3,5', 'A4', 'B1', 'B2', 'B3', 'B4', 'C1', 'C2', 'C3', 'C4', 'D2', 'D3', 'D4', 'OM2', 'OM3', 'Stellar White']),
              }
            },
            DDZXColor: {
              label: 'DD Bio ZX² color',
              tooltip: 'Festigkeit: 1150 ± 150 Mpa. Anatomisch reduzierte Krone, Vollanatomische Krone Seitenzahn, Primärteleskop, Anatomisch reduzierte Brücke (bis 3 Brückenglieder), Anatomisch reduzierte Brücke (bis 14 Glieder), Vollanatomische Brücke (bis 3 Brückenglieder), Vollanatomische Brücke (bis 14 Glieder), Hybrid-Abutment und Steg',
              tooltipSize: 'xlarge',
              itemnum: '1.1.4',
              properties: {
                color: colors(['A1', 'A2', 'A3', 'A3,5', 'A4', 'B1', 'B2', 'B3', 'B4', 'C1', 'C2', 'C3', 'C4', 'D2', 'D3', 'D4']),
              }
            },
            DDZWIsoColor: {
              label: 'DD Bio ZW iso color',
              tooltip: 'Festigkeit: 1150 ± 200 MPa. Anatomisch reduzierte Krone, Primärteleskop, Anatomisch reduzierte Brücke (bis 3 Glieder), Anatomisch reduzierte Brücke (bis 14 Glieder) und Hybrid-Abutment',
              tooltipSize: 'xlarge',
              itemnum: '1.1.7',
              properties: {
                color: colors(['A1', 'A2', 'A3', 'A3,5', 'B1', 'B2', 'C1', 'D2']),
              }
            }
          }
        },
        Telescope: {
          label: 'Zirkon Primärteleskop',
          children: {
            DDZXColor: {
              label: 'DD Bio ZX² color',
              tooltip: 'Festigkeit: 1150 ± 150 Mpa. Anatomisch reduzierte Krone, Vollanatomische Krone Seitenzahn, Primärteleskop, Anatomisch reduzierte Brücke (bis 3 Glieder), Anatomisch reduzierte Brücke (bis 14 Glieder), Vollanatomische Brücke (bis 3 Glieder), Vollanatomische Brücke (bis 14 Glieder), Hybrid-Abutment und Steg',
              tooltipSize: 'xlarge',
              itemnum: '1.1.4',
              properties: {
                color: colors(['A1', 'A2', 'A3', 'A3,5', 'A4', 'B1', 'B2', 'B3', 'B4', 'C1', 'C2', 'C3', 'C4', 'D2', 'D3', 'D4']),
              }
            },
            DDZWIsoColor: {
              label: 'DD Bio ZW iso color',
              tooltip: 'Festigkeit: 1150 ± 200 MPa. Anatomisch reduzierte Krone, Primärteleskop, Anatomisch reduzierte Brücke (bis 3 Glieder), Anatomisch reduzierte Brücke (bis 14 Glieder) und Hybrid-Abutment',
              tooltipSize: 'xlarge',
              itemnum: '1.1.7',
              properties: {
                color: colors(['A1', 'A2', 'A3', 'A3,5', 'B1', 'B2', 'C1', 'D2']),
              }
            },
          }
        },
        Abutment: {
          label: 'Zirkon Abutment',
          children: {
            BredentLuxor: {
              label: 'Bredent Luxor Z (Premium)',
              tooltip: 'Festigkeit: ≥ 1.100 MPa im cervicalen Bereich und ≥ 750 MPa im höheren incisalen Bereich. Geeignet für mehrspannige Brücken.',
              itemnum: '1.1.1',
              properties: {
                color: colors(['A1', 'A2', 'A3', 'A3,5', 'A4', 'B1', 'B2', 'B3', 'B4', 'C2', 'C3', 'C4', 'D2', 'D3', 'D4', 'Bleach']),
                additionalInfo: {
                  type: 'html',
                  value: 'Implantatteile sind unter dem Reiter Zusatzprodukte erhältlich.',
                }
              }
            },
            DDZXColor: {
              label: 'DD Bio ZX² color',
              tooltip: 'Festigkeit: 1150 ± 150 Mpa. Anatomisch reduzierte Krone, Vollanatomische Krone Seitenzahn, Primärteleskop, Anatomisch reduzierte Brücke (bis 3 Glieder), Anatomisch reduzierte Brücke (bis 14 Glieder), Vollanatomische Brücke (bis 3 Glieder), Vollanatomische Brücke (bis 14 Glieder), Hybrid-Abutment und Steg',
              tooltipSize: 'xlarge',
              itemnum: '1.1.4',
              properties: {
                color: colors(['A1', 'A2', 'A3', 'A3,5', 'A4', 'B1', 'B2', 'B3', 'B4', 'C1', 'C2', 'C3', 'C4', 'D2', 'D3', 'D4']),
                additionalInfo: {
                  type: 'html',
                  value: 'Implantatteile sind unter dem Reiter Zusatzprodukte erhältlich.',
                }
              }
            },
            DDZWIsoColor: {
              label: 'DD Bio ZW iso color',
              tooltip: 'Festigkeit: 1150 ± 200 MPa. Anatomisch reduzierte Krone, Primärteleskop, Anatomisch reduzierte Brücke (bis 3 Glieder), Anatomisch reduzierte Brücke (bis 14 Glieder) und Hybrid-Abutment',
              tooltipSize: 'xlarge',
              itemnum: '1.1.7',
              properties: {
                color: colors(['A1', 'A2', 'A3', 'A3,5', 'B1', 'B2', 'C1', 'D2']),
              }
            },
          }
        },
      }
    },
    CoCr: {
      label: 'CoCr',
      properties: {
        mat: {
          type: 'html',
          value: 'Material: System Soft Blank',
        }
      },
      children: {
        milled: {
          label: 'CoCr gefräst',
          properties: {
          },
          children: {
            milled_blend: {
              label: 'CoCr Gerüst zum Verblenden',
              itemnum: '1.2.1',
              maxunits: 100,
              properties: {
                cocr_geschiebe: {
                  label: 'Geschiebe',
                  type: 'select',
                  options: generateOptions(100, '1.2.19')
                },
                cocr_teilgeschiebe: {
                    label: 'Teilungsgeschiebe',
                    type: 'select',
                    options: generateOptions(100, '1.2.20')
                },
              }
            },
            milled_anatomic: {
              label: 'CoCr Gerüst teil- oder vollanatomisch',
              itemnum: '1.2.2',
              maxunits: 100,
              properties: {
                cocr_geschiebe: {
                  label: 'Geschiebe',
                  type: 'select',
                  options: generateOptions(100, '1.2.19')
                },
                cocr_teilgeschiebe: {
                    label: 'Teilungsgeschiebe',
                    type: 'select',
                    options: generateOptions(100, '1.2.20')
                },
              }
            },
            milled_prim_tele: {
              label: 'CoCr Primärteleskope',
              itemnum: '1.2.3',
              maxunits: 100,
              properties: {
                '2in1TK': {
                  label: '2in1 TK',
                  itemnum: 'SP7'
                }
              },
            },
            milled_abut: {
              label: 'CoCr Abutment',
              itemnum: '1.2.4',
              maxunits: 100,
              properties: {
                mat: {
                  type: 'html',
                  value: 'Material: Medentika Preface',
                }
              }
            },
            milled_sec: {
              label: 'CoCr Sekundärteleskope',
              properties: {
                count: {
                  label: 'Anzahl der Sekundärteleskope',
                  type: 'select',
                  required: true,
                  defaultValue: 1,
                  options: generateOptions(100, '1.2.5')
                },
                retention: {
                  label: 'Retention',
                  type: 'select',
                  options: generateQuadrants('1.2.6')
                },
                connector: {
                  label: 'Löt-/Klebeverbinder',
                  type: 'select',
                  options: generateOptions(25, '1.2.7')
                },
                uk_mogu: {
                  label: 'Modellguss gefräst',
                  itemnum: '1.2.18'
                },
                tk_soft: {
                  label: 'TK-Soft',
                  type: 'select',
                  options: generateOptions(50, '1.2.21')
                },
                milled_blend: {
                  label: 'Gerüst zum Verblenden',
                  type: 'select',
                  options: generateOptions(50, '1.2.1')
                },
                milled_anatomic: {
                  label: 'Gerüst teil- oder vollanatomisch',
                  type: 'select',
                  options: generateOptions(50, '1.2.2')
                },
                mat: {
                  type: 'html',
                  value: 'Material: System Soft Blank',
                },
                additionalInfo: {
                  type: 'html',
                  value: 'Friktionselemente sind unter dem Reiter Zusatzprodukte erhältlich.',
                }
              }
            },
            cocr_mogu: {
              label: 'CoCr Modellguss',
              itemnum: '1.2.18',
              properties: {
                mat: {
                  type: 'html',
                  value: 'Material: System Soft Blank',
                },
              }
            },
            milled_adhesive_bar: {
              label: 'CoCr Steg auf Klebebasen',
              properties: {
                milled_ab_implants: {
                  label: 'Anzahl der Implantate',
                  type: 'select',
                  required: true,
                  defaultValue: 2,
                  options: generateOptions(7, '1.2.', (x => 'CoCr Steg auf Klebebasen, ' + x + ' Implantate, gefräst'), 2, true, 10)
                },
                mat: {
                  type: 'html',
                  value: 'Material: System Soft Blank',
                },
                additionalInfo: {
                  type: 'html',
                  value: 'Implantatteile sind unter dem Reiter Zusatzprodukte erhältlich.',
                }
              }
            },
            milled_implant_bridge: {
              label: 'CoCr Implantatbrücke',
              properties: {
                milled_ib_implants: {
                  label: 'Anzahl der Implantate',
                  type: 'select',
                  required: true,
                  defaultValue: 2,
                  options: generateOptions(5, '1.2.', (x => 'CoCr Implantatbrücke, ' + x + ' Implantate, gefräst'), 2, true, 22)
                },
                mat: {
                  type: 'html',
                  value: 'Material: System Soft Blank',
                },
                additionalInfo: {
                  type: 'html',
                  value: 'Implantatteile sind unter dem Reiter Zusatzprodukte erhältlich.',
                }
              },
            },
            milled_bar_connector: {
              label: 'CoCr Steg mit Anschlüssen',
              maxunits: 100,
              properties: {
                milled_bc_implants: {
                  label: 'Anzahl der Anschlüsse',
                  type: 'select',
                  defaultValue: 2,
                  options: generateOptions(5, '1.2.', (x => 'CoCr Steg mit ' + x + ' Anschlüssen, gefräst'), 2, true, 27)
                },
                mat: {
                  type: 'html',
                  value: 'Material: System Soft Blank',
                },
                additionalInfo: {
                  type: 'html',
                  value: 'Implantatteile sind unter dem Reiter Zusatzprodukte erhältlich.',
                }
              }
            },
            milled_bar_holder: {
              label: 'CoCr Stegüberwurf mit Halteelementen',
              properties: {
                milled_bh_implants: {
                  label: 'Anzahl der Kiefer',
                  type: 'select',
                  required: true,
                  options: generateJaw('1.2.17')
                },
                mat: {
                  type: 'html',
                  value: 'Material: System Soft Blank',
                },
                additionalInfo: {
                  type: 'html',
                  value: 'Halteelemente (Preci vertix/horix) sind unter dem Reiter Zusatzprodukte erhältlich.',
                }
              }
            },
            milled_pen: {
              label: 'CoCr Stiftaufbau',
              itemnum: '1.2.9',
              maxunits: 100,
            },
            milled_tert: {
              label: 'CoCr Tertiärkonstruktion',
              properties: {
                milled_tert_implants: {
                  label: 'Anzahl der Kiefer',
                  type: 'select',
                  required: true,
                  options: generateJaw('1.2.8')
                },
                mat: {
                  type: 'html',
                  value: 'Material: System Soft Blank',
                },
              }
            },
          }
        },
        slm: {
          label: 'CoCr Laser Melting',
          properties: {
            mat: {
              type: 'html',
              value: 'Material: remanium star® powder',
            },
          },
          children: {
            slm_blend: {
              label: 'CoCr Gerüst zum Verblenden',
              itemnum: '1.3.1',
              maxunits: 100,
              properties: {
                cocr_geschiebe: {
                  label: 'Geschiebe',
                  type: 'select',
                  options: generateOptions(100, '1.3.7')
                },
                cocr_teilgeschiebe: {
                    label: 'Teilungsgeschiebe',
                    type: 'select',
                    options: generateOptions(100, '1.3.8')
                },
                mat: {
                  type: 'html',
                  value: 'Material: remanium star® powder',
                },
              }
            },
            slm_anatomic: {
              label: 'CoCr Gerüst teil- oder vollanatomisch',
              itemnum: '1.3.2',
              maxunits: 100,
              properties: {
                cocr_geschiebe: {
                  label: 'Geschiebe',
                  type: 'select',
                  options: generateOptions(100, '1.3.7')
                },
                cocr_teilgeschiebe: {
                    label: 'Teilungsgeschiebe',
                    type: 'select',
                    options: generateOptions(100, '1.3.8')
                },
                mat: {
                  type: 'html',
                  value: 'Material: remanium star® powder',
                },
              }
            },
            slm_prim_tele: {
              label: 'CoCr Primärteleskope',
              itemnum: '1.3.3',
              maxunits: 100,
            },
            slm_sec: {
              label: 'CoCr Sekundärteleskope',
              properties: {
                count: {
                  label: 'Anzahl der Sekundärteleskope',
                  type: 'select',
                  required: true,
                  defaultValue: 1,
                  options: generateOptions(100, '1.3.4')
                },
                retention: {
                  label: 'Retention',
                  type: 'select',
                  options: generateQuadrants('1.3.5')
                },
                connector: {
                  label: 'Löt-/Klebeverbinder',
                  type: 'select',
                  options: generateOptions(25, '1.3.6')
                },
                clamp_mogu_shiny: {
                  label: 'Klammermodellguss glänzend',
                  type: 'select',
                  options: generateOptions(100, '1.3.13')
                },
                clamp_mogu_bland: {
                  label: 'Klammermodellguss matt',
                  type: 'select',
                  options: generateOptions(100, '1.3.12')
                },
                mogu_shiny: {
                  label: 'Modellguss glänzend',
                  type: 'select',
                  options: generateOptions(100, '1.3.11')
                },
                mogu_bland: {
                  label: 'Modellguss matt',
                  type: 'select',
                  options: generateOptions(100, '1.3.10')
                },
                tk_soft: {
                  label: 'TK-Soft',
                  type: 'select',
                  options: generateOptions(10, '1.3.15')
                },
                slm_blend: {
                  label: 'Gerüst zum Verblenden',
                  type: 'select',
                  options: generateOptions(50, '1.3.1')
                },
                slm_anatomic: {
                  label: 'Gerüst teil- oder vollanatomisch',
                  type: 'select',
                  options: generateOptions(50, '1.3.2')
                },
                mat: {
                  type: 'html',
                  value: 'Material: remanium star® powder',
                },
                additionalInfo: {
                  type: 'html',
                  value: 'Friktionselemente sind unter dem Reiter Zusatzprodukte erhältlich.',
                }
              }
            },
            slm_adhesive_bar: {
              label: 'CoCr Steg auf Klebebasen',
              properties: {
                slm_ab_implants: {
                  label: 'Anzahl der Implantate',
                  type: 'select',
                  required: true,
                  defaultValue: 2,
                  options: generateOptions(5, '1.3.', (x => 'CoCr Steg auf Klebebasen, ' + x + ' Implantate, slm'), 2, true, 17)
                },
                mat: {
                  type: 'html',
                  value: 'Material: remanium star® powder',
                },
                additionalInfo: {
                  type: 'html',
                  value: 'Implantatteile sind unter dem Reiter Zusatzprodukte erhältlich.',
                }
              }
            },
            slm_bar_holder: {
              label: 'CoCr Stegüberwurf mit Halteelementen',
              properties: {
                slm_bh_implants: {
                  label: 'Anzahl der Kiefer',
                  type: 'select',
                  required: true,
                  defaultValue: 1,
                  options: generateJaw('1.3.16')
                },
                mat: {
                  type: 'html',
                  value: 'Material: remanium star® powder',
                },
                additionalInfo: {
                  type: 'html',
                  value: 'Halteelemente (Preci vertix/horix) sind unter dem Reiter Zusatzprodukte erhältlich.',
                }
              }
            },
            slm_pen: {
              label: 'CoCr Stiftaufbau',
              itemnum: '1.3.14',
              maxunits: 100,
            },
            slm_tert: {
              label: 'CoCr Tertiärkonstruktion',
              properties: {
                slm_tert_implants: {
                  label: 'Anzahl der Kiefer',
                  type: 'select',
                  required: true,
                  defaultValue: 1,
                  options: generateJaw('1.3.9')
                },
                slm_tert_shiny: {
                  label: 'Aufschlag für Glänzen je Kiefer',
                  itemnum: '1.3.24' // TODO check
                },
                mat: {
                  type: 'html',
                  value: 'Material: remanium star® powder',
                },
              }
            },
          }
        },
        mogu_slm: {
          label: 'CoCr Modellguss laser melting',
          properties: {
            mat: {
              type: 'html',
              value: 'Material: remanium star® powder',
            },
          },
          children: {
            clamp_mogu_shiny: {
              label: 'Klammermodellguss glänzend',
              properties: {
                jaws: {
                  label: 'Anzahl der Kiefer',
                  type: 'select',
                  required: true,
                  defaultValue: 1,
                  options: generateJaw('1.3.13')
                },
              }
            },
            clamp_mogu_bland: {
              label: 'Klammermodellguss matt',
              properties: {
                jaws: {
                  label: 'Anzahl der Kiefer',
                  type: 'select',
                  required: true,
                  defaultValue: 1,
                  options: generateJaw('1.3.12')
                },
              }
            },
            mogu_shiny: {
              label: 'Modellguss glänzend',
              properties: {
                jaws: {
                  label: 'Anzahl der Kiefer',
                  type: 'select',
                  required: true,
                  defaultValue: 1,
                  options: generateJaw('1.3.11')
                },
              }
            },
            mogu_bland: {
              label: 'Modellguss matt',
              properties: {
                jaws: {
                  label: 'Anzahl der Kiefer',
                  type: 'select',
                  required: true,
                  defaultValue: 1,
                  options: generateJaw('1.3.10')
                },
              }
            },
          }
        }
      }
    },
    ks: {
      label: 'Kunststoff',
      children: {
        models: {
          label: '3D-Druck',
          children: {
            model_jaw: {
              label: 'Modell je Kiefer',
              properties: {
                jaws: {
                  label: 'Anzahl der Kiefer',
                  type: 'select',
                  required: true,
                  defaultValue: 1,
                  options: [{value: 1, amount: 1, itemnum: '1.5.1', label: 'Ein Kiefer'}]//generateJaw('1.5.1')
                },
                /*stump: {
                  label: 'Stumpf zusätzlich, gedruckt',
                  type: 'select',
                  options: generateOptions(100, '1.5.4')
                },
                mask: {
                  label: 'Zahnfleischmaske, gedruckt',
                  type: 'select',
                  options: generateOptions(100, '1.5.3')
                },*/
                additionalInfo: {
                  type: 'html',
                  value: 'Material: Shera print-model desert',
                }
              }
            },
            model_quad: {
              label: 'Modell je Quadrant',
              properties: {
                quads: {
                  label: 'Quadranten',
                  type: 'select',
                  required: true,
                  defaultValue: 1,
                  options: generateQuadrants('1.5.2')
                },
                stump: {
                  label: 'Stumpf zusätzlich, gedruckt',
                  type: 'select',
                  options: generateOptions(100, '1.5.4')
                },
                mask: {
                  label: 'Zahnfleischmaske, gedruckt',
                  type: 'select',
                  options: generateOptions(100, '1.5.3')
                },
                additionalInfo: {
                  type: 'html',
                  value: 'Material: Shera print-model desert',
                }
              }
            },
            print_stump: {
              label: 'Einzelstumpf',
              properties: {
                masks: {
                  label: 'Anzahl der Stümpfe',
                  type: 'select',
                  required: true,
                  defaultValue: 1,
                  options: generateOptions(50, '1.5.4')
                },
                additionalInfo: {
                  type: 'html',
                  value: 'Material: Shera print-model desert',
                }
              }
            },
            print_gingiva_mask: {
              label: 'Zahnfleischmaske',
              properties: {
                masks: {
                  label: 'Anzahl der Zahnfleischmasken',
                  type: 'select',
                  required: true,
                  defaultValue: 1,
                  options: generateOptions(50, '1.5.3')
                },
                color: {
                  type: 'html',
                  value: 'Farbe: rosa'
                },
                additionalInfo: {
                  type: 'html',
                  value: 'Material: organic 3D Gingiva ECO',
                }
              }
            },
            print_spoon: {
              label: 'Löffel',
              properties: {
                masks: {
                  label: 'Anzahl der Löffel',
                  type: 'select',
                  required: true,
                  defaultValue: 1,
                  options: generateOptions(50, '1.5.5')
                },
                additionalInfo: {
                  type: 'html',
                  value: 'Material: printodent GR-11 tray orange',
                }
              }
            },
            print_art: {
              label: 'Indiv. Artikulator, gedruckt',
              properties: {
                count: {
                  label: 'Anzahl der Kiefer',
                  type: 'select',
                  required: true,
                  defaultValue: 1,
                  options: generateJaw('1.5.6')
                },
                additionalInfo: {
                  type: 'html',
                  value: 'Material: Shera print-model desert',
                }
              }
            },
            print_mogu: {
              label: 'Modellguss, ausbrennbar',
              properties: {
                masks: {
                  label: 'Anzahl der Modellgüsse',
                  type: 'select',
                  required: true,
                  defaultValue: 1,
                  options: generateOptions(50, '1.5.6')
                },
                additionalInfo: {
                  type: 'html',
                  value: 'Material: Asiga DentaMODEL',
                }
              }
            },
          },
        },
        splints: {
          label: 'Schienen',
          children: {
            pmma_splint: {
              label: 'Pmma Schiene, gefräst',
              properties: {
                count: {
                  label: 'Anzahl der Schienen',
                  type: 'select',
                  required: true,
                  defaultValue: 1,
                  options: generateOptions(50, '1.4.1')
                },
                color: {
                  type: 'html',
                  value: 'Farbe: clear'
                },
                additionalInfo: {
                  type: 'html',
                  value: 'Material: DD Bio Splint P HI',
                }
              }
            },
            bego_splint: {
              label: 'Bego E-splint Schiene, gefräst',
              properties: {
                count: {
                  label: 'Anzahl der Schienen',
                  type: 'select',
                  required: true,
                  defaultValue: 1,
                  options: generateOptions(50, '1.4.2')
                },
                color: {
                  type: 'html',
                  value: 'Farbe: clear'
                },
                additionalInfo: {
                  type: 'html',
                  value: 'Material: Bego PMMA Splint E',
                }
              }
            },
            eldy_splint: {
              label: 'Eldy Schiene, gefräst',
              properties: {
                count: {
                  label: 'Anzahl der Schienen',
                  type: 'select',
                  required: true,
                  defaultValue: 1,
                  options: generateOptions(50, '1.4.3')
                },
                color: colors(['A1', 'A2', 'A3', 'A3,5', 'Rosa', 'clear']),
                additionalInfo: {
                  type: 'html',
                  value: 'Material: Eldy Plus® Mono',
                }
              }
            },
            pmma_splint: {
              label: 'Pmma Schiene zahnfarbend, gefräst',
              properties: {
                count: {
                  label: 'Anzahl der Schienen',
                  type: 'select',
                  required: true,
                  defaultValue: 1,
                  options: generateOptions(50, '1.4.4')
                },
                additionalInfo: {
                  type: 'html',
                  value: 'Material: M-PM® Disc',
                }
              }
            },
            clear_splint: {
              label: 'Astron® CLEARsplint® Schiene, gefräst',
              properties: {
                count: {
                  label: 'Anzahl der Schienen',
                  type: 'select',
                  required: true,
                  defaultValue: 1,
                  options: generateOptions(50, '1.4.21')
                },
                //color: colors(['A1', 'A2', 'A3', 'A3,5', 'Rosa', 'clear']),
                additionalInfo: {
                  type: 'html',
                  value: 'Material: Astron® CLEARsplint®',
                }
              }
            },
            print_splint: {
              label: 'Schiene, gedruckt',
              properties: {
                count: {
                  label: 'Anzahl der Schienen',
                  type: 'select',
                  required: true,
                  defaultValue: 1,
                  options: generateOptions(50, '1.5.8')
                },
                color: {
                  type: 'html',
                  value: 'Farbe: clear'
                },
                additionalInfo: {
                  type: 'html',
                  value: 'Material: keyprint KeySplint Soft',
                }
              }
            },
            print_template: {
              label: 'Bohrschablone, gedruckt',
              properties: {
                count: {
                  label: 'Anzahl der Bohrschablonen',
                  type: 'select',
                  required: true,
                  defaultValue: 1,
                  options: generateOptions(50, '1.5.9')
                },
                color: {
                  type: 'html',
                  value: 'Farbe: Orange Transparent'
                },
                additionalInfo: {
                  type: 'html',
                  value: 'Material: Organic 3D Surgical',
                }
              }
            },
            snaponsmile: {
              label: 'Snap on Smile je Kiefer',
              properties: {
                count: {
                  label: 'Anzahl der Kiefer',
                  type: 'select',
                  required: true,
                  defaultValue: 1,
                  options: generateJaw('1.4.22')
                },
                additionalInfo: {
                  type: 'html',
                  value: 'Material: Eldy Plus® Multicolor',
                }
              }
            },
          }
        },
        anatomic: {
          label: 'Kst. Gerüste',
          children: {
            anatomic_pmma_single: {
              label: 'Pmma Gerüst einfarbig, gefräst',
              itemnum: '1.4.7',
              maxunits: 50,
              properties: {
                color: colors(),
                anatomic_geschiebe: {
                  label: 'Geschiebe',
                  itemnum: '1.4.9'
                },
                additionalInfo: {
                  type: 'html',
                  value: 'Material: M-PM® Disc',
                }
              }
            },
            anatomic_pmma_color: {
              label: 'Pmma Gerüst mit Farbverlauf, gefräst',
              itemnum: '1.4.8',
              maxunits: 50,
              properties: {
                color: colors(['A1', 'A2', 'A3', 'A3,5', 'B2', 'C2', 'C3', 'D2', 'D3']),
                additionalInfo: {
                  type: 'html',
                  value: 'Material: breCAM.multiCOM',
                }
              }
            },
            anatomic_eldy_single: {
              label: 'Eldy Gerüst einfarbig, gefräst',
              itemnum: '1.4.12',
              maxunits: 50,
              properties: {
                color: colors(['A1', 'A2', 'A3', 'A3,5', 'Rosa', 'clear']),
                additionalInfo: {
                  type: 'html',
                  value: 'Material: Eldy Plus® Mono',
                }
              }
            },
            anatomic_eldy_color: {
              label: 'Eldy Gerüst mit Farbverlauf, gefräst',
              itemnum: '1.4.13',
              maxunits: 50,
              properties: {
                color: colors(['A1-A2', 'A2-A3', 'A3-A3,5', 'B1-B2', 'B2-B3', 'C2-C3']),
                additionalInfo: {
                  type: 'html',
                  value: 'Material: Eldy Plus® Multicolor',
                }
              }
            },
            anatomic_ivotion: {
              label: 'Ivotion Dent Gerüst, gefräst',
              itemnum: '1.4.11',
              maxunits: 50,
              properties: {
                color: colors('A1', 'A2', 'A3', 'A3,5', 'B1', 'B3', 'BL3', 'C2', 'D2'),
                additionalInfo: {
                  type: 'html',
                  value: 'Material: Ivotion Dent',
                }
              }
            },
            print_anatomic: {
              label: 'Kst. Gerüst gedruckt',
              itemnum: '1.5.7',
              maxunits: 50,
              properties: {
                color: colors(['A2', 'A3']),
                additionalInfo: {
                  type: 'html',
                  value: 'Material: printodent GR-17 temporary',
                }
              }
            },
          }
        },
        dentures: {
          label: 'Eldy Klammerprothesen',
          children: {
            eldy_denture_ok: {
              label: 'Eldy Invisible Denture, OK',
              itemnum: '1.4.20',
              properties: {
                additionalInfo: {
                  type: 'html',
                  value: 'Material: Eldy Plus® Mono',
                }
              }
            },
            eldy_denture_uk: {
              label: 'Eldy Invisible Denture, UK',
              itemnum: '1.4.5',
              properties: {
                additionalInfo: {
                  type: 'html',
                  value: 'Material: Eldy Plus® Mono',
                }
              }
            },
            eldy_denture_quad: {
              label: 'Eldy Invisible Denture je Quadrant, gefräst',
              itemnum: '1.4.6',
              properties: {
                additionalInfo: {
                  type: 'html',
                  value: 'Material: Eldy Plus® Mono',
                }
              }
            },
          }
        },
        biohpp_sec: {
          label: 'Bredent BioHPP (PEEK)',
          children: {
            sec: {
              label: 'BioHPP Sekundärteleskope',
              properties: {
                count: {
                  label: 'Anzahl der Sekundärteleskope',
                  type: 'select',
                  required: true,
                  defaultValue: 1,
                  options: generateOptions(100, '1.4.14')
                },
                color: colors(['Dentin Shade 2', 'Rosa', 'White']),
                biohpp_retention: {
                  label: 'BioHPP Retentionen',
                  type: 'select',
                  options: generateQuadrants('1.4.18')
                },
                biohpp_adhesive: {
                  label: 'BioHPP Klebeverbinder',
                  type: 'select',
                  options: generateOptions(25, '1.4.19')
                },
                biohpp_mogu: {
                  label: 'BioHPP Modellguss',
                  itemnum: '1.4.15',
                },
                biohpp_tksoft: {
                  label: 'BioHPP TK-Soft',
                  type: 'select',
                  options: generateOptions(50, '1.4.17')
                },
                biohpp_scaffold: {
                  label: 'BioHPP Gerüst',
                  type: 'select',
                  options: generateOptions(50, '1.4.16')
                },
                additionalInfo: {
                  type: 'html',
                  value: 'Friktionselemente sind unter dem Reiter Zusatzprodukte erhältlich.<br/>Material: breCAM.BioHPP',
                }
              }
            },
            biohpp_scaffold: {
              label: 'BioHPP Gerüste, gefräst',
              properties: {
                count: {
                  label: 'Anzahl der Gerüste',
                  type: 'select',
                  options: generateOptions(50, '1.4.16')
                }
              }
            },
            biohpp_prefab: {
              label: 'BioHPP elegance prefab, gefräst',
              properties: {
                count: {
                  label: 'Anzahl der Abutments',
                  type: 'select',
                  required: true,
                  defaultValue: 1,
                  options: generateOptions(50, '1.4.10')
                },
                color: {
                  type: 'html',
                  value: 'Farbe: Dentin Shade 2'
                },
                additionalInfo: {
                  type: 'html',
                  value: 'Material: breCAM.BioHPP elegance prefabs',
                }
              }
            }
          }
        },
      }
    },
    glas: {
      label: 'Glaskeramik',
      maxunits: 100,
      //tooltip: '<b>Biegefestigkeit von 530 MPa</b><br/>Indikationen:<br/>• Kronen<br/>• Inlays<br/>• Onlays (z.B. okklusale Veneers, Teilkronen)<br/>• Veneers<br/>• 3-gliedrigen Brücken bis zum zweiten Prämolaren als endständigem<br/>Pfeiler<br/>• implantatgetragenen Hybrid-Versorgungen<br/>(Hybrid-Abutments, Hybrid-Abutment-Kronen)',
      tooltipSize: 'xlarge',
      properties: {
        sinter: {
          label: 'Kristallisationsbrand',
          itemnum: 'SP3'
        }
      },
      children: {
        emax_LT: {
          label: 'IPS e.max CAD LT',
          itemnum: '1.6.3',
          properties: {
            color: colors(['A1', 'A2', 'A3', 'A3,5', 'A4', 'B1', 'B2', 'B3', 'B4', 'C1', 'C2', 'C3', 'C4', 'D2', 'D3', 'D4', 'BL1', 'BL2', 'BL3', 'BL4']),
            additionalInfo: {
              type: 'html',
              value: 'Der Vielseitige<br/>IPS e.max CAD LT (Low Translucency)<br/>LT-Blöcke sind aufgrund ihrer niedrigen Transluzenz ideal für die Herstellung von größeren Restaurationen (z. B. Seitenzahnkronen) geeignet. Restaurationen aus LT-Blöcken überzeugen durch Helligkeit und Chroma.<br/><br/><a href="https://www.ivoclar.com/de_de/products/digital-processes/ips-e.max-cad">Link</a>',
            }
          }
        },
        emax_MT: {
          label: 'IPS e.max CAD MT',
          itemnum: '1.6.2',
          properties: {
            color: colors(['A1', 'A2', 'A3', 'B1', 'BL2', 'BL3', 'BL4']),
            additionalInfo: {
              type: 'html',
              value: 'Der Helle<br/>IPS e.max CAD MT (Medium Translucency)<br/>MT-Blöcke weisen eine mittlere Transluzenz auf und werden für Restaurationen verwendet, bei denen mehr Helligkeit als bei HTRestaurationen und mehr Transluzenz als bei LT-Restaurationen benötigt wird.<br/><br/><a href="https://www.ivoclar.com/de_de/products/digital-processes/ips-e.max-cad">Link</a>',
            }
          }
        },
        emax_HT: {
          label: 'IPS e.max CAD HT',
          itemnum: '1.6.1',
          properties: {
            color: colors(['A1', 'A2', 'A3', 'A3,5', 'A4', 'B1', 'B2', 'B3', 'B4', 'C1', 'C2', 'C3', 'C4', 'D2', 'D3', 'D4', 'BL1', 'BL2', 'BL3', 'BL4']),
            additionalInfo: {
              type: 'html',
              value: 'Der Minimalinvasive<br/>IPS e.max CAD HT (High Translucency)<br/>HT-Blöcke sind aufgrund ihrer hohen Transluzenz ideal für die Herstellung von kleinen Restaurationen (z. B. Inlays, Onlays) geeignet. Restaurationen aus HT-Blöcken überzeugen durch einen Chamäleon-Effekt für eine natürliche Integration.<br/><br/><a href="https://www.ivoclar.com/de_de/products/digital-processes/ips-e.max-cad">Link</a>',
            }
          }
        },
        emax_MO: {
          label: 'IPS e.max CAD MO',
          itemnum: '1.6.4',
          properties: {
            color: colors(['MO 0', 'MO 1', 'MO 2', 'MO 3', 'MO 4']),
            additionalInfo: {
              type: 'html',
              value: 'Der Klassische<br/>IPS e.max CAD MO (Medium Opacity)<br/>MO-Blöcke sind aufgrund ihrer Opazität ideal für die Herstellung von Gerüsten auf leicht verfärbten Stümpfen und werden hauptsächlich im zahntechnischen Labor verwendet.<br/><br/><a href="https://www.ivoclar.com/de_de/products/digital-processes/ips-e.max-cad">Link</a>',
            }
          }
        },
        amber: {
          label: 'Amber® Mill CAD/CAM',
          itemnum: '1.6.5',
          indications: ['K', 'KV', 'KM', 'V', 'PK', 'B', 'BV', 'BM', 'KH', 'KVH'],
          properties: {
            color: colors(['A1', 'A2', 'A3', 'A3,5', 'A4', 'B1', 'B2', 'B3', 'B4', 'C1', 'C2', 'C3', 'C4', 'D2', 'D3', 'D4', 'W1', 'W2', 'W3', 'W4']),
          }
        },
      }
    },
    ti: {
      label: 'Titan',
      children: {
        scaffold: {
          label: 'Titan Gerüst, gefräst',
          itemnum: '1.7.1',
          maxunits: 50,
          properties: {
            additionalInfo: {
              type: 'html',
              value: 'Material: TITAN BioStar Grade 5',
            }
          }
        },
        prim_tele: {
          label: 'Titan Primärteleskop, gefräst',
          itemnum: '1.7.2',
          maxunits: 50,
          properties: {
            additionalInfo: {
              type: 'html',
              value: 'Material: TITAN BioStar Grade 5',
            }
          }
        },
        sec_tele: {
          label: 'Titan Sekundärteleskope, gefräst',
          properties: {
            count: {
              label: 'Anzahl der Sekundärteleskope',
              type: 'select',
              required: true,
              defaultValue: 1,
              options: generateOptions(50, '1.7.3')
            },
            retention: {
              label: 'Retention',
              type: 'select',
              options: generateQuadrants('1.7.4')
            },
            connector: {
              label: 'Löt-/Klebeverbinder',
              type: 'select',
              options: generateOptions(25, '1.7.5')
            },
            "Modellguss gefräst": {
              label: 'Modellguss gefräst',
              itemnum: '1.7.6'
            },
            "TK-Soft": {
              label: 'TK-Soft',
              type: 'select',
              options: generateOptions(10, '1.7.7')
            },
            additionalInfo: {
              type: 'html',
              value: 'Friktionselemente sind unter dem Reiter Zusatzprodukte erhältlich.<br/>Material: TITAN BioStar Grade 5',
            }
          }
        },
        ti_multi: {
          label: 'Titan Multiunit all on …',
          properties: {
            tk_soft: {
              label: 'Anzahl',
              type: 'select',
              defaultValue: 2,
              options: generateOptions(7, '1.7.', (x => 'Titan Multiunit all on ' + x + ', gefräst'), 2, true, 8)
            },
            additionalInfo: {
              type: 'html',
              value: 'Implantatteile sind unter dem Reiter Zusatzprodukte erhältlich.<br/>Material: TITAN BioStar Grade 5',
            }
          }
        },
        ti_abut: {
          label: 'Titan Abutments, gefräst',
          maxunits: 50,
          children: {
            ti_med: {
              label: 'Medentika',
              itemnum: '1.7.15',
              properties: {
                additionalInfo: {
                  type: 'html',
                  value: 'Material: Titan Medentika Preface',
                }
              }
            },
            ti_dd: {
              label: 'Dental Direkt',
              itemnum: '1.7.16',
              properties: {
                additionalInfo: {
                  type: 'html',
                  value: 'Material: DD Prefab',
                }
              }
            },
            ti_straumann: {
              label: 'Straumann original',
              itemnum: '1.7.17',
              properties: {
                additionalInfo: {
                  type: 'html',
                  value: 'Material: Straumann original Abutment',
                }
              }
            },
            ti_sic: {
              label: 'SIC',
              itemnum: '1.7.18',
              properties: {
                additionalInfo: {
                  type: 'html',
                  value: 'Material: SIC Abutment',
                }
              }
            },
            ti_copa: {
              label: 'copaSky',
              itemnum: '1.7.19',
              properties: {
                additionalInfo: {
                  type: 'html',
                  value: 'Material: SIC Abutment',
                }
              }
            },
          }
        }
      }
    },
    wax: {
      label: 'Wachs',
      maxunits: 100,
      children: {
        brecam: {
          label: 'Bredent breCam.wax',
          itemnum: '1.8.1',
          properties: {
          }
        },
      }
    },
  }
}
